import React from 'react';
import { CheckIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { includedItems, totalFacts } from '../data/content';
export function Included() {
  return <section className="w-full bg-plum-50 py-16 md:py-24" data-id="element-126" data-mp="4e26bhq7tz97">
      <div className="mx-auto w-full max-w-content px-5 md:px-8" data-id="element-127" data-mp="4chcjubq6kce">
        <SectionHeading eyebrow="Resumen" title={<>
              Todo esto <span className="italic text-gold-700" data-id="element-129" data-mp="x1y1uj41tl4e">está incluido</span>
            </>} data-id="element-128" data-mp="3vm7nmevjy3ya" />

        <div className="mx-auto mt-14 max-w-4xl overflow-hidden rounded-xl bg-white shadow-card" data-id="element-130" data-mp="s4pgyarin2zg">
          <ul className="divide-y divide-plum-100 px-7 py-4 md:px-10" data-id="element-131" data-mp="n3i8salgo1s9">
            {includedItems.map(item => <li key={item} className="flex items-start gap-3 py-4" data-id="element-132" data-mp="i5qexb19a5lf">
                <CheckIcon className="mt-1 h-5 w-5 shrink-0 text-teal-500" aria-hidden="true" data-id="element-133" data-mp="37w3ks9q6u88c" />
                <span className="text-ink" data-id="element-134" data-mp="32v627w19nc6b">{item}</span>
              </li>)}
          </ul>

          <div className="bg-plum-900 px-7 py-9 text-center text-white md:px-10" data-id="element-135" data-mp="35suzsqzft70k">
            <p className="text-[0.7rem] font-bold uppercase tracking-[0.2em] text-gold-300" data-id="element-136" data-mp="3aqwkfgcihee5">
              En total
            </p>
            <p className="mt-4 font-display text-2xl font-extrabold leading-tight md:text-[2.2rem]" data-id="element-137" data-mp="2vsug33xnoovu">
              4 tomos + 30 tarjetas + 3 bonos
            </p>
            <ul className="mt-7 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-sm text-plum-200" data-id="element-138" data-mp="2n0seh2bup2jz">
              {totalFacts.map(fact => <li key={fact} className="inline-flex items-center gap-2" data-id="element-139" data-mp="2rtll5vqvqkyp">
                  <span className="h-1.5 w-1.5 rounded-full bg-gold-500" aria-hidden="true" data-id="element-140" data-mp="2d4peo34h1g07" />
                  {fact}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}